import { QueryClient } from '@tanstack/react-query';
import { ErroApi } from '@/shared/lib/api';

/**
 * `staleTime` por tipo de dado (.spec/004, seção 3.3): cadastro muda pouco,
 * movimento muda o tempo todo.
 */
export const STALE_TIME = {
  cadastro: 5 * 60 * 1000,
  movimento: 30 * 1000,
} as const;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME.movimento,
      retry: (tentativa, erro) => {
        // Erro de negócio ou de permissão não melhora com retentativa — só
        // atrasa o feedback ao usuário.
        if (erro instanceof ErroApi && erro.status < 500) return false;
        return tentativa < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: { retry: false },
  },
});
